/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./youtube.vue?vue&type=template&id=778bffcf&scoped=true"
import script from "./youtube.vue?vue&type=script&lang=js"
export * from "./youtube.vue?vue&type=script&lang=js"
import style0 from "./youtube.vue?vue&type=style&index=0&id=778bffcf&prod&lang=scss"
import style1 from "./youtube.vue?vue&type=style&index=1&id=778bffcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778bffcf",
  null
  
)

export default component.exports